module.exports = __webpack_public_path__ + "img/banner.a6dd804.jpg";